import Axios from "axios";

import { SET_SALARY_COMPPONENT_LIST, UNSET_SALARY_COMPPONENT_LIST} from "@/store/mutation-types";

import {
  salaryComponentList as salaryComponentListApi,
  saveUpdateSalaryComponent as saveUpdateSalaryComponentApi,
} from "@/store/api";

const state = {
  salaryComponentList: [],
  editingsalaryComponent: null,
};

const getters = {
  salaryComponentList(state) {
    return state.salaryComponentList;
  },
  editingsalaryComponent: (state) => state.editingsalaryComponent,
};


// Mutations
const mutations = {
  [SET_SALARY_COMPPONENT_LIST](state, data) {
    state.salaryComponentList = data;
  },
  [UNSET_SALARY_COMPPONENT_LIST](state) {
    state.salaryComponentList = [];
  },
  editingsalaryComponent(state, data) {
    state.editingsalaryComponent = data;
  },
};

// Actions
const actions = {

    saveUpdateSalaryComponent({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateSalaryComponentApi, data)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {

            reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

  salaryComponentList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${salaryComponentListApi}`, { params: data })
        .then((response) => {
          commit(SET_SALARY_COMPPONENT_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_SALARY_COMPPONENT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
  
};


export default {
  state,
  getters,
  actions,
  mutations,
};